import { ApiProperty } from '@nestjs/swagger'
import { IsEmail, IsNotEmpty, IsString, Length, MinLength } from 'class-validator'

export class VerifyEmailRequest {
	@ApiProperty({ type: String, format: 'email' })
	@IsNotEmpty()
	@IsString()
	@IsEmail()
	email: string
}

export class VerifyTokenRequest {
	@ApiProperty({ type: String })
	@IsNotEmpty()
	@IsString()
	token: string
}

export class VerifyTokenResponse {
	@ApiProperty({ type: String, format: 'email' })
	email: string
}

export class RegisterRequest {
	@ApiProperty({ type: String, minLength: 2, maxLength: 60 })
	@IsNotEmpty()
	@IsString()
	@Length(2, 60)
	firstName: string

	@ApiProperty({ type: String, minLength: 2, maxLength: 60 })
	@IsNotEmpty()
	@IsString()
	@Length(2, 60)
	lastName: string

	@ApiProperty({ type: String, format: 'email' })
	@IsNotEmpty()
	@IsString()
	@IsEmail()
	email: string

	@ApiProperty({ type: String, format: 'password' })
	@IsNotEmpty()
	@IsString()
	@MinLength(8)
	password: string
}
